import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-feather',
  templateUrl: './icon-feather.component.html',
  styleUrls: ['./icon-feather.component.scss']
})
export class IconFeatherComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
